import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchGameStats } from '../../redux/slices/gameStatsSlice';
import { selectTask } from '../../redux/slices/tasksSlice';

const pad = (n) => String(n).padStart(2, '0');

// ISO-строка -> DD.MM.YYYY HH:MM
const formatDateTime = (value) => {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '—';
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// секунды -> M:SS или H:MM:SS
const formatDuration = (seconds) => {
    if (seconds == null || Number.isNaN(Number(seconds))) return '—';
    const total = Math.max(0, Math.round(Number(seconds)));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
};

export default function TaskStats({ task }) {
    const dispatch = useAppDispatch();
    const { taskId, games, status } = useAppSelector((state) => state.gameStats);
    const isCurrent = taskId === task.id;

    useEffect(() => {
        dispatch(fetchGameStats(task.id));
    }, [dispatch, task.id]);

    // свежие игры сверху
    const sorted = [...games].sort((a, b) => new Date(b.playedAt) - new Date(a.playedAt));

    return (
        <div className="task-stats">
            <div className="task-editor__header">
                <h2 className="task-stats__title">Статистика: {task.title}</h2>
                <button className="task-btn task-btn--secondary" onClick={() => dispatch(selectTask(task.key))}>
                    Открыть задание
                </button>
            </div>

            {(!isCurrent || status === 'loading') && <p className="task-hint">Загрузка статистики…</p>}
            {isCurrent && status === 'failed' && (
                <p className="task-error">Не удалось загрузить статистику с сервера</p>
            )}
            {isCurrent && status === 'succeeded' && sorted.length === 0 && (
                <p className="task-hint">По этому заданию ещё никто не играл</p>
            )}

            {isCurrent && status === 'succeeded' && sorted.length > 0 && (
                <table className="stats-table">
                    <thead>
                        <tr>
                            <th>Название игры</th>
                            <th>Дата игры</th>
                            <th className="stats-table__num">Время прохождения</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.map((game, i) => (
                            <tr key={game.id ?? i}>
                                <td>{game.name || <span className="task-hint">Без названия</span>}</td>
                                <td>{formatDateTime(game.playedAt)}</td>
                                <td className="stats-table__num">{formatDuration(game.durationSeconds)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
